<script>
	import model from "../../stores/modelStore";

	import confirmationPages from "../confirmationPages";
	import { projectSettings } from "../../config";

	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import ReviewSectionHeader from "../../components/ReviewSectionHeader.svelte";
	import DropZone from "../../components/DropZone.svelte";

	let disabled = true;

	document.title = `${projectSettings.classActionName} - Review`;
</script>

<section>
	<FormRow class="justify-content-center">
		<FormColumn>
			<h1 class="text-center">{@html projectSettings.classActionName} Shift Class Actions</h1>
		</FormColumn>
	</FormRow>

	<div class="confirmation">
		{#each confirmationPages as page, i}
			{#if page.loopOver}
				{#each $model.claimDetails as employmentDetails}
					<!-- <ConfirmationSectionHeader heading={page.confirmationHeading} routeId={page.routeId}
					></ConfirmationSectionHeader> -->
					{#key employmentDetails.businessId}
						<svelte:component this={page.component} {disabled} businessId={employmentDetails.businessId} />
					{/key}
				{/each}
			{:else}
				<ReviewSectionHeader heading={page.confirmationHeading} routeId={page.routeId}></ReviewSectionHeader>

				<svelte:component this={page.component} {disabled} />
			{/if}
		{/each}
		<ReviewSectionHeader heading={"Uploaded Documents"}></ReviewSectionHeader>
		<hr class="primary" />
		<FormRow class="confirmation">
			<FormColumn>
				<DropZone
					{disabled}
					message="<strong>Upload files for your registration</strong><br />Drag files here or click to upload"
					bind:documentList={$model.documentList}></DropZone>
			</FormColumn>
		</FormRow>
	</div>
</section>
